import React from "react"
import { Field, ErrorMessage } from "formik";
import WindowedSelect from "react-windowed-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from "@fortawesome/free-solid-svg-icons";

const GroupId = ({ errors, touched, values, isAddMode, userGroups }) => {
    return (
        <div className="col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className="col-md-3">
                        <label className="otg-formlabel">User Group
                            <span className="otg-reqicon">
                                <FontAwesomeIcon icon={faAsterisk} />
                            </span>
                        </label>
                    </div>
                    <div className="col-md-9">
                        <Field
                            name="GroupId"
                            as="select"
                            className={
                                "form-control" +
                                (errors.GroupId && touched.GroupId
                                    ? " is-invalid"
                                    : "")
                            }
                            disabled={!isAddMode}
                        >
                            <option key="" value="">
                                Select User Group
                            </option>
                            {userGroups.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </Field>
                        <ErrorMessage
                            name="GroupId"
                            component="div"
                            className="invalid-feedback"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const UserName = ({
    errors,
    setFieldValue,
    values,
    isAddMode,
    primaryContactSuggestions,
    loadSuggestion,
    resetPrimaryContact
}) => {
    return (
        <div className=" col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className=" col-md-3">
                        <label className="otg-formlabel">
                            User Name
                            <span className="otg-reqicon">
                                <FontAwesomeIcon icon={faAsterisk} />
                            </span>
                        </label>
                    </div>
                    <div className=" col-md-9">
                        <Field
                            name="UserName"
                            type="text"
                            className={"form-control" + (errors?.UserName ? " is-invalid" : "")}
                            onChange={val => {
                                loadSuggestion(val, "Primary").then(
                                    setFieldValue("UserName", val?.currentTarget?.value || '')
                                        .then(() => {
                                            if (values.EmailId && !val.currentTarget.value)
                                                setFieldValue("EmailId", "")
                                        }));
                            }}
                            disabled={!isAddMode}
                        />
                        <ul className="suggestions">
                            {primaryContactSuggestions &&
                                primaryContactSuggestions.map(suggestion => {
                                    return (
                                        <li
                                            key={suggestion}
                                            onClick={() => {
                                                setFieldValue("UserName", suggestion.displayName);
                                                setFieldValue("EmailId", suggestion.mail);
                                                resetPrimaryContact()
                                            }}>
                                            {suggestion.displayName}
                                        </li>
                                    );
                                })}
                        </ul>
                        <ErrorMessage
                            name="UserName"
                            component="div"
                            className="invalid-feedback"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Email = ({ errors, touched }) => {
    return (
        <div className="col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className=" col-md-3">
                        <label className="otg-formlabel">
                            Email
                            <span className="otg-reqicon">
                                <FontAwesomeIcon icon={faAsterisk} />
                            </span>
                        </label>
                    </div>
                    <div className=" col-md-9">
                        <Field
                            name="EmailId"
                            type="text"
                            className={
                                "form-control" +
                                (errors.EmailId && touched.EmailId ?
                                    " is-invalid" : "")
                            }
                            disabled={true}
                        />
                        <ErrorMessage
                            name="EmailId"
                            component="div"
                            className="invalid-feedback"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const PhoneNumber = ({ errors }) => {
    return (
        <div className="col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className=" col-md-3">
                        <label className="otg-formlabel">Phone Number</label>
                    </div>
                    <div className=" col-md-9">
                        <Field
                            name="PhoneNumber"
                            type="text"
                            className={
                                "form-control" +
                                (errors?.PhoneNumber ? " is-invalid" : "")
                            }
                        />
                        <ErrorMessage
                            name="PhoneNumber"
                            component="div"
                            className="invalid-feedback"
                        />
                        <div className="otgTextCmt">
                            The Phone Number must be with country code,
                            for example if country code is +1 and number is
                            1234567890 then enter +11234567890 .
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Active = () => {
    return (
        <div className=" col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className=" col-md-3">
                        <label className="otg-formlabel">Active (Y/N)</label>
                    </div>
                    <div className=" col-md-9">
                        <Field name="IsActive" type="checkbox" />
                    </div>
                </div>
            </div>
        </div>
    )
}

const Region = ({ touched, onRegionChange, isAddMode, regions, regionDefaultValue }) => {
    return (
        <div className=" col-md-6">
            <div className="form-group">
                <div className="row">
                    <div className=" col-md-3">
                        <label className="otg-formlabel">
                            Region
                        </label>
                    </div>
                    <div className=" col-md-9">
                        <Field
                            name="Region"
                            as="select"
                            className={"form-control" + touched?.Region ?
                                " is-invalid" : ""}
                            disabled={!isAddMode}
                        >
                            {
                                props => {
                                    return (
                                        <WindowedSelect
                                            options={regions}
                                            onChange={onRegionChange}
                                            value={regions.filter(val => 
                                                val.label === regionDefaultValue
                                            )}
                                        />
                                    )
                                }
                            }

                        </Field>
                        <ErrorMessage
                            name="Region"
                            component="div"
                            className="invalid-feedback"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export const ButtonsComponent = ({ isSubmitting, closeForm }) => {
    return (
        <div className="form-group btnotg-pos">
            <button
                type="submit"
                disabled={isSubmitting}
                className="btn btn-primary controlotg-btns"
            >
                {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                )}
                Save
            </button>
            <button
                type="cancel"
                disabled={isSubmitting}
                className="btn btn-primary controlotg-btns"
                onClick={closeForm}
            >
                {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                )}
                Cancel
            </button>
        </div>
    )
}


export const FacilityFormFields = (props) => {
    return (
        <>
            <div className="row">
                <GroupId {...props} />
                <UserName {...props} />
            </div>
            <div className="row">
                <Email {...props} />
                <PhoneNumber {...props} />
            </div>
            <div className="row">
                <Active {...props} />
            </div>
            <div className="row">
                <Region {...props} />
            </div>
        </>
    )
}